// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"d7a91dc9","141":"9c465fb3","394":"a8a66140","484":"d7d13bc8","498":"83f804ee","580":"9a8a999e","584":"a5def514","620":"a36c693a","747":"aac34003","925":"d02cd88e"}[chunkId] + ".chunk.js";
};